<template>
	<div class="bg-white px-3" style="margin: -20px;margin-top: -1rem;margin-bottom: 0!important;">
		<div class="d-flex pt-3">
			<el-button type="primary" icon="el-icon-search" size="mini" >查询</el-button>
			<el-button type="success" size="mini" @click="states(multipleSelection)">领取客户</el-button>
		</div>

		<el-table :data="tableData" style="width: 100%;" @selection-change="handleSelectionChange" size="mini" key="table1" :max-height="maxHeight">
			<el-table-column type="selection" width="45" align="center"></el-table-column>
			<el-table-column align="center" prop="id" width="50" label="编号" fixed="left"></el-table-column>
			<el-table-column prop="mc" label="客户名称" width="200"></el-table-column>
			<el-table-column align="center" label="释放人">
				<template slot-scope="scope">
					<el-button type="success" size="mini" plain>{{scope.row.sfr.name}}</el-button>
				</template>
			</el-table-column>
			<el-table-column align="center" label="释放时间" width="130">
				<template slot-scope="scope">
					{{scope.row.sfsj.slice(0,10)}}
				</template>
			</el-table-column>
			<el-table-column prop="xssl" align="center" label="线索数量"></el-table-column>
			<el-table-column align="center" label="线索更新时间" width="130">
				<template slot-scope="scope">
					{{scope.row.xsgx.slice(0,10)}}
				</template>
			</el-table-column>
			<el-table-column align="center" label="创建时间" width="130">
				<template slot-scope="scope">
					{{scope.row.create_time.slice(0,10)}}
				</template>
			</el-table-column>
			<el-table-column align="center" label="操作" fixed="right" width="180">
				<template slot-scope="scope">
					<el-button type="primary" size="mini" @click="navigate('khgl_khgl_khxx_ck',scope.row)">查看</el-button>
					<el-select v-model="value" placeholder="更多" size="mini" style="width: 75px;margin-left: 10px;">
						<el-option value="1"><p @click="navigate('khgl_khgl_khxx_khzl',scope.row)">客户资料</p></el-option>
						<el-option value="2"><p @click="navigate('khgl_khgl_khxx_lxr',scope.row)">联系人</p></el-option>
					</el-select>
				</template>
			</el-table-column>
		</el-table>
		<el-footer class="border-top d-flex align-items-center px-0 position-fixed bg-white" style="bottom: 0;left: 250px;right: 0;z-index: 100;">
			<div style="flex: 1;" class="px-2">
				<el-pagination
					:current-page="page.current"
					:page-sizes="page.sizes"
					:page-size="page.size"
					layout="total, sizes, prev, pager, next, jumper"
					:total="page.total"
					@size-change="handleSizeChange"
					@current-change="handleCurrentChange"
				></el-pagination>
			</div>
		</el-footer>

	</div>
</template>

<script>
import common from '@/common/mixins/common.js';
import { mapState } from 'vuex';
export default {
	mixins: [common],
	inject: ['layout'],
	data() {
		return {
			preUrl: 'khxxgh',
			form: {
				// 表单值
				khxx: {
					title: '',
					content: '' 
				}
			},
			tableData: [],
			maxHeight: 0,
			multipleSelection:[],
			value:'更多'
		};
	},
	// 计算属性
	computed: {
		// 引入store-modules的user模块里面的user(存储用户相关的数据)
		...mapState({
			user: state => state.user.user
		})
	},
	mounted() {
		this.$nextTick(() => {
			this.maxHeight = window.innerHeight - 274; //300是页面中除了表格外其他组件的高度
		});
	},
	methods: {
		// 鼠标单击的事件
		navigate(name, e) {
			var data = {
				id:e.id,
				mc:e.mc,
				desc:e.desc,
				lxr:e.lxr,
				sjhm:e.sjhm,
				dhhm:e.dhhm,
				email:e.email,
				dq:e.dq,
				xxdz:e.xxdz,
				khzt:e.khzt,
				gx:e.gx.name,
				cjr:e.cjr.name,
				sfr:e.sfr.name,
				create_time:e.create_time,
				xsge:e.xsge
			}
			this.$router.push({
				name,
				params: { data }
			})
		},
		getListUrl() {
			return `/admin/${this.preUrl}/${this.page.current}?limit=${this.page.size}`;
		},
		getListResult(e) {
			this.tableData = e.list
			console.log(this.tableData)
		},
		states(f){
			let x = f.map(i=>{
				return i.id
			})
			let i = {
				zrr:this.user.id,
				ids:x,
			}
			this.axios.post('/admin/khxx/lqgh', i,{
				token: true
			}).then(res => {
				this.getList()
			})
		},
		handleSelectionChange(val) {
		        this.multipleSelection = val;
		}
	}
};
</script>

<style>
.el-collapse-item__header {
	/* display: flex; */
	align-items: center;
	height: 48px;
	line-height: 48px;
	margin-left: 10px;
	cursor: pointer;
	font-size: 13px;
	/* font-weight: 500; */
	transition: border-bottom-color 0.3s;
	outline: 0;
}
.demo-table-expand {
	font-size: 0;
}
.demo-table-expand label {
	width: 90px;
	color: #99a9bf;
}
.demo-table-expand .el-form-item {
	margin-right: 0;
	margin-bottom: 0;
	width: 50%;
}
.el-dropdown-link {
	cursor: pointer;
	color: #ff8c00;
}
.el-icon-arrow-down {
	font-size: 12px;
}
</style>
